// extracted by mini-css-extract-plugin
module.exports = {"signUp":"signUp-module--signUp--3mLmu","store":"signUp-module--store--3LNQW","icon":"signUp-module--icon--f6vrx","bgCircles":"signUp-module--bgCircles--2dAPR"};